<div class="container">
  <div class="header-top-container row justify-content-between">
    <div class="d-flex align-items-center">
      <button id="kuba-navigation-toggle" type="button" class="kuba-icon-button"
        [attr.aria-label]="'NAVIGATION' | translate" aria-controls="kuba-navigation"
        [attr.aria-expanded]="navigation.expanded()" (click)="navigation.toggle()">
        <i class="pi pi-bars" aria-hidden="true"></i>
      </button>
      <branding></branding>
    </div>
    <div class="col-auto d-flex align-items-center"></div>
    <div class="col-auto d-flex align-items-center">
      <!--Languages directive-->
      <div class="language-wrapper">
        <languages></languages>
      </div>
      <div class="top-links d-flex align-items-center h-100">
        <div class="top-link-item hse-course">
          <button *ngIf="!isMedi3 && !isAgil"
            class="btn btn-primary px-2 py-1"
            (click)="openUpgradeUrlInNewTab()"
          >
            <span>{{ "UPGRADE" | translate }}</span>
          </button>
          <button
            class="btn btn-primary px-2 py-1"
            (click)="openCourseUrlInNewTab()"
          >
            <span>{{ "HSE_COURSE" | translate }}</span>
          </button>
        </div>
        <div class="top-link-item kb-quick-help px-2" *ngIf="!userrole">
          <!--Quick Help-->
          <quick-help></quick-help>
        </div>
        <!-- TERMS AND CONDITIONS LINK - ONLY VISIBLE IN IK PLATFORM -->
        <div *ngIf="showTermsButton" class="top-link-item">
          <button
            class="btn btn-primary px-2 py-1"
            (click)="openTermsUrlInNewTab()"
          >
            <span>{{ "TERMS" | translate }}</span>
          </button>
        </div>

        <div class="top-link-item profile px-2">
          <!--User Profile-->
          <user-profile></user-profile>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog
  header="{{ 'INFORMATION' | translate }}"
  [(visible)]="isSearchEmpty"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  {{ "KEYWORD_SEARCH" | translate }}
  <ng-template pTemplate="footer">
    <button
      type="button"
      class="btn btn-link"
      title="{{ 'OK' | translate }}"
      (click)="informationHide()"
      translate
    >
      {{ "OK" | translate }}
    </button>
  </ng-template>
</p-dialog>
